<h1 mat-dialog-title>Estamos em manutenção</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 500px;">
    <div class="row mt-4">
        <div class="col-auto">
            <img style="width: 200px; margin-right: 8px; margin-left: 8px;" title="Manutenção"
                src="./assets/manutencao.jpg">
        </div>

        <div class="col-sm text-center">
            <div class="row">
                <div class="col-sm text-center">
                    {{data.descricao}}
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-sm text-center">
                    Previsão de retorno: <div style="font-weight: 500;">{{data.previsaoRetorno}}</div>
                </div>
            </div>
        </div>


    </div>

    <div class="row">
        <div class="col-sm">

        </div>
    </div>
</div>